module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_19.2dd7d58a.pdf";